import { atomWithReset } from "jotai/utils";
import { DEFAULT_COMPONENTS_STATE, getDefaultComponentsState } from "./defaultComponentsState";

export const componentsAtom = atomWithReset(getDefaultComponentsState());
